// Mock data for Ol' McToodles Electric

export const companyInfo = {
  name: "Ol' McToodles Electric",
  tagline: "Efficiency Embodied",
  location: "Fernie, BC, Canada",
  postalCode: "V0B1M5",
  phone: "(250)430-1242",
  email: "info@olmctoodles.ca"
};

export const services = [
  {
    id: 1,
    title: "Residential Electrical",
    description: "Complete home electrical services including installations, repairs, and upgrades for safe and efficient power. Silver Label inspections are also available for modular and mobile homes that require recertification before sale or after alterations.",
    icon: "Home"
  },
  {
    id: 2,
    title: "Commercial Solutions",
    description: "Professional electrical systems for businesses, offices, and retail spaces with minimal downtime. Equipment Servicing, Lighting and Power Upgrades, Service and Maintenance Contracts, showcase, equipment, and parking lot lighting to update and highlight your business and help reduce necessary operational energy costs.",
    icon: "Building2"
  },
  {
    id: 3,
    title: "Industrial Services",
    description: "Heavy-duty electrical installations and maintenance for industrial facilities and equipment. Automation and control system installation and support, network infrastructure installations and servicing, HVAC control systems installations and retrofits, industrial fire pump control systems operations and maintenance, water and wastewater pump and control system installation and maintenance, remote site/equipment power and communications solutions, maintenance planning and consultations for your facility and operational needs.",
    icon: "Factory"
  },
  {
    id: 4,
    title: "Panel Upgrades",
    description: "Modern electrical panel installations and upgrades to meet current safety codes and power demands.",
    icon: "CircuitBoard"
  },
  {
    id: 5,
    title: "Emergency Repairs",
    description: "24/7 emergency electrical services to keep your home or business running safely.",
    icon: "AlertCircle"
  },
  {
    id: 6,
    title: "Energy Efficiency",
    description: "LED lighting, smart home integration, Electric Vehicle (EV) power and energy management systems, and energy-saving solutions to reduce your power costs.",
    icon: "Zap"
  }
];

export const renewableServices = [
  {
    id: 1,
    title: "Solar Power Systems",
    description: "Grid-tied and off-grid solar panel installations with battery backup for reliable clean energy.",
    icon: "Sun"
  },
  {
    id: 2,
    title: "Mini-Hydro Systems",
    description: "Small-scale hydroelectric installations for properties with water resources. Sustainable 24/7 power generation.",
    icon: "Droplets"
  },
  {
    id: 3,
    title: "Micro-Wind Turbines",
    description: "Small wind turbine installations for homesteads and rural properties to harness wind power.",
    icon: "Wind"
  },
  {
    id: 4,
    title: "Off-Grid Solutions",
    description: "Complete off-grid electrical systems combining solar, wind, and hydro with battery storage.",
    icon: "Battery"
  },
  {
    id: 5,
    title: "Battery Storage",
    description: "Advanced battery backup systems for energy independence and grid resilience.",
    icon: "BatteryCharging"
  },
  {
    id: 6,
    title: "Homestead Power",
    description: "Custom electrical solutions for rural homesteads, farms, and remote properties. Includes backup generator installs (propane/diesel/gas) with auto-start charging features.",
    icon: "TreePine"
  }
];

export const projects = [
  {
    id: 1,
    title: "Mountain Resort Renovation",
    category: "Commercial",
    description: "Complete electrical overhaul for luxury mountain resort in Fernie",
    image: "https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=800"
  },
  {
    id: 2,
    title: "Modern Home Build",
    category: "Residential",
    description: "Full electrical installation for new construction with smart home features",
    image: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=800"
  },
  {
    id: 3,
    title: "Off-Grid Homestead",
    category: "Renewable",
    description: "Complete solar and battery system for remote mountain property",
    image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800"
  },
  {
    id: 4,
    title: "Mini-Hydro Installation",
    category: "Renewable",
    description: "Small hydroelectric system for creek-side property with year-round power",
    image: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=800"
  },
  {
    id: 5,
    title: "Industrial Facility",
    category: "Industrial",
    description: "Professional electrical systems for manufacturing plant",
    image: "https://images.unsplash.com/photo-1581094271901-8022df4466f9?w=800"
  },
  {
    id: 6,
    title: "Downtown Office Complex",
    category: "Commercial",
    description: "Energy-efficient lighting and power distribution for office building",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800"
  },
  {
    id: 7,
    title: "Solar Farm Integration",
    category: "Renewable",
    description: "Grid-tied solar array with battery backup for agricultural operation",
    image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?w=800"
  },
  {
    id: 8,
    title: "Heritage Home Upgrade",
    category: "Residential",
    description: "Panel upgrade and rewiring for historic home preservation",
    image: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800"
  },
  {
    id: 9,
    title: "Retail Store Installation",
    category: "Commercial",
    description: "Custom lighting and electrical setup for boutique retail space",
    image: "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?w=800"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Homeowner",
    content: "Outstanding service! They upgraded our entire electrical panel and added smart home features. Professional, efficient, and reasonably priced.",
    rating: 5
  },
  {
    id: 2,
    name: "Tom Henderson",
    role: "Business Owner",
    content: "Ol' McToodles Electric handled our commercial building renovation perfectly. Zero downtime and excellent attention to detail.",
    rating: 5
  },
  {
    id: 3,
    name: "Jennifer Parks",
    role: "Property Manager",
    content: "We use them for all our properties in Fernie. Reliable, licensed, and always responsive to emergency calls. Highly recommended!",
    rating: 5
  }
];

export const certifications = [
  {
    id: 1,
    title: "Licensed Electrical Contractor",
    description: "Fully licensed in British Columbia - LIC-00215081",
    icon: "Award"
  },
  {
    id: 2,
    title: "Insured & Bonded",
    description: "Comprehensive liability coverage",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Safety Certified",
    description: "Technical Safety BC FSR-B - CER-00010107",
    icon: "CheckCircle"
  },
  {
    id: 4,
    title: "Code Compliant",
    description: "All work meets BC electrical codes",
    icon: "FileCheck"
  }
];

export const socialLinks = [
  { platform: "Facebook", url: "#", icon: "Facebook" },
  { platform: "Instagram", url: "#", icon: "Instagram" },
  { platform: "LinkedIn", url: "#", icon: "Linkedin" },
  { platform: "Twitter", url: "#", icon: "Twitter" }
];
